import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { GetActiveCurtailmentSitesList } from "../api";
import { useAuth0 } from "@auth0/auth0-react";

type GetActiveCurtailmentSitesListProps = {
  isOpen: boolean;
  refetchInterval?: number; // optional polling interval in ms
};

type Site = {
  siteName: string;
  end_time: Date;
};

export const UseGetActiveCurtailmentSitesList = (
  options: GetActiveCurtailmentSitesListProps
): UseQueryResult<{ status: string; activeCurtailSchedule: Site[] }, Error> => {
  const { isOpen, refetchInterval } = options;
  const { getAccessTokenSilently } = useAuth0();

  return useQuery({
    queryKey: ["getActiveCurtailSiteList"],
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      return GetActiveCurtailmentSitesList(token);
    },
    staleTime: 0,
    enabled: isOpen,
    notifyOnChangeProps: "all",
    refetchInterval,
  });
};
